const ENTRA_CLIENT_ID = process.env?.REACT_APP_ENTRA_CLIENT_ID ?? '';
const ENTRA_TENANT_ID = process.env?.REACT_APP_ENTRA_TENANT_ID ?? '';
const ENTRA_AUTHORITY = `https://login.microsoftonline.com/${ENTRA_TENANT_ID}`;
const REDIRECT_URI = `${window.location.origin}/login/callback`;

const config = {
  auth: {
    clientId: ENTRA_CLIENT_ID,
    authority: ENTRA_AUTHORITY,
    redirectUri: REDIRECT_URI,
  },
  cache: {
    cacheLocation: 'sessionStorage', // This configures where your cache will be stored
    storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
  },
};

// Export scopes separately for use in login requests
// Use standard Microsoft identity scopes that work with any app registration
export const loginScopes = ['openid', 'profile', 'email'];

// For backend API calls, we'll request tokens with our client ID as the resource/audience
export const apiScopes = [ENTRA_CLIENT_ID];

export default config;
